module.exports = "<div class=\"notification-wrapper\">\n  <cm-notification *ngIf=\"notification\" [notification]=\"notification\" (click)=\"goto(notification.chatId)\"></cm-notification>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/notification/notification-factory/notification-factory.component.html
// module id = ../../../../../src/app/notification/notification-factory/notification-factory.component.html
// module chunks = 4